import { Theme } from "@mui/material";
import * as monaco from "monaco-editor";
import { CompilationMessage } from "../../graphql/types";

function noop() {}

function getOrCreateModel(value: string, language: string, path: string) {
  return getModel(path) || createModel(value, language, path);
}

function getModel(path: string) {
  return monaco.editor.getModel(createModelUri(path));
}

function createModel(value: string, language: string, path: string) {
  return monaco.editor.createModel(value, language, path ? createModelUri(path) : undefined);
}

function createModelUri(path: string) {
  return monaco.Uri.parse(path);
}

function createSBSMarkers(compilationMessages: CompilationMessage[] | null | undefined) {
  const markerSeverity: Record<string, monaco.MarkerSeverity> = {
    error: monaco.MarkerSeverity.Error,
    warning: monaco.MarkerSeverity.Warning,
    info: monaco.MarkerSeverity.Info,
    beta: monaco.MarkerSeverity.Warning,
  };

  if (!compilationMessages) return;
  const markers: monaco.editor.IMarkerData[] = [];
  compilationMessages.forEach((message) => {
    const marker: monaco.editor.IMarkerData = {
      severity: markerSeverity[message.type],
      startLineNumber: message.startLine,
      endLineNumber: message.endLine,
      startColumn: message.startColumn,
      endColumn: message.endColumn === message.startColumn ? message.endColumn : message.endColumn + 1, // bug. Monaco doesn't put the squiggly under the last column for some reason
      message: message.message,
    };
    markers.push(marker);
  });
  return markers;
}

const copyToClipboard = (ed: monaco.editor.ICodeEditor) => {
  const selected = ed.getSelection();
  const linesParam = `lines=${selected?.startLineNumber}-${selected?.endLineNumber}-${selected?.startColumn}-${selected?.endColumn}`;
  const actualUrl = window.location.href;
  if (actualUrl.includes("lines=")) {
    const url = actualUrl.replace(/lines=[^&]+/, linesParam);
    navigator.clipboard.writeText(url);
  } else {
    const url = actualUrl + `&${linesParam}`;
    navigator.clipboard.writeText(url);
  }
};

type GetSbsThemeType = (
  theme: Theme,
  currentTheme: "vs-dark" | "vs"
) => {
  base: monaco.editor.BuiltinTheme;
  rules: monaco.editor.ITokenThemeRule[];
  inherit: boolean;
  colors: monaco.editor.IColors;
};

const getSbsTheme: GetSbsThemeType = (theme, vsTheme) => ({
  base: vsTheme,
  rules: [
    { token: "keyword", foreground: theme.palette.dataCerulean.main, fontStyle: "bold" },
    { token: "comment", foreground: theme.palette.text30.main },
    { token: "string", foreground: theme.palette.primary70.main },
    { token: "type", foreground: theme.palette.primary70.main, fontStyle: "bold" },
  ],
  inherit: true,
  colors: {},
});

export { copyToClipboard, createSBSMarkers, getOrCreateModel, getSbsTheme, noop };
